import useResize from '@anm/hooks/useResize';
import { useEffect, useState } from 'react';

const useWindowWidthCheck = (maxWidth: number) => {
  const [isInRange, setIsInRange] = useState(false);

  const checkCb = () => setIsInRange(window.innerWidth < maxWidth);

  useResize(checkCb);

  useEffect(() => {
    checkCb();
  }, []);

  return isInRange;
};

export default useWindowWidthCheck;
